import { NavigationParams } from "../utils/navigation";
import { AgentEndpoint, ChatResponse, NavigationDataResponse } from "../types/navigation";
import { fetchEventSource } from '@microsoft/fetch-event-source';

export const BASE = process.env.REACT_APP_BACKEND_URL || "";

export const API_ENDPOINT_CHAT = "/chat";

export async function getAgentEndpoints(): Promise<AgentEndpoint[]> {
  const response = await fetch(`${BASE}${API_ENDPOINT_CHAT}/agents`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }
  });

  const data = (await response.json()) as AgentEndpoint[];
  return data;
}

export async function fetchQuery(params: NavigationParams, chatEndpoint?: string): Promise<NavigationDataResponse> {
  const controller = new AbortController();

  console.log("fetchQuery traceId:", params.traceId, "userId:", params.userId);

  try {
    const response = await fetch(`${BASE}${API_ENDPOINT_CHAT}/chatstream`, {
      method: 'POST',
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'text/event-stream',
      },
      body: JSON.stringify({
        query: params.userQuery,
        sessionId: params.traceId,
        userId: params.userId,
        endpoint: chatEndpoint,
      }),
    });

    if (!response.ok || !response.body) {
      return { message: 'Something went wrong. Please try again later', nav: [] };
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      const lines = buffer.split('\n');
      buffer = lines.pop() ?? '';

      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed || trimmed.startsWith(':')) continue; // skip heartbeats

        if (trimmed.startsWith('data:')) {
          const jsonStr = trimmed.slice(5).trim();
          try {
            const parsed = JSON.parse(jsonStr);
            console.log('parsed', parsed);
            if (parsed.event === 'end') {
              controller.abort();
              return {
                type: parsed.data.type,
                message: parsed.data.text,
                nav: parsed.data.nav,
                navLink: parsed.data.navLink,
              };
            }
          } catch (e) {
            console.warn('Failed to parse SSE line', trimmed);
          }
        }
      }
    }
  } catch (err: any) {
    if (err.name === 'AbortError') {
      console.log('Stream aborted cleanly');
    } else {
      console.warn('Fetch error', err);
    }
  }

  return { message: 'Please try again later', nav: [] };
}

export async function fetchPath(
  params: NavigationParams,
  onChunk?: (chunk: string) => void,
  signalController?: AbortController): Promise<NavigationDataResponse> {

  const url = new URL(API_ENDPOINT_CHAT, BASE).toString();
  let endEventReceived = false;

  console.log(`traceId: ${params.traceId}, userId: ${params.userId}`)
  console.log(`current location ${params.userLocation?.lat}, ${params.userLocation?.lng}`)
  console.log(`mode: ${params.is_disability}`)
  console.log(`start POI: ${params.startPoi}`)
  let locationQuery = ""
  if (params.userLocation != null) {
    if (params.startPoi != null) {
      locationQuery = `I am near ${params.startPoi}.`
    }
  }

  let modeQuery = ""
  if (params.is_disability === "1") {
    modeQuery = "I am disabled."
  }

  const finalQuery = `${locationQuery} ${modeQuery} ${params.userQuery}`
  console.log(`finalQuery: ${finalQuery}`)
  return new Promise((resolve, reject) => {
    console.log("fetch url", url)
    fetchEventSource(url, {
      signal: signalController?.signal,
      method: 'POST',
      body: JSON.stringify({
        query: finalQuery,
        trace_id: params.traceId,
        user_id: params.userId,
        lang: params.lang === 'en' ? 'en' : 'zh_HK',
        lat: params.userLocation?.lat.toString(),
        lng: params.userLocation?.lng.toString()
      }),
      headers: { 'Content-Type': 'application/json' },

      onopen: async (response) => {
        if (!response.ok) {
          throw new Error(`Unexpected response: ${response.status}`);
        }
      },

      onmessage(event) {
        try {
          if (!event.data || event.data.startsWith(':')) return;

          const parsed = JSON.parse(event.data);
          console.log("parsed", parsed)
          if (parsed.event === 'update') {
            onChunk?.(parsed.data.message);
          } else if (parsed.event === 'end') {
            endEventReceived = true;
            resolve(parsed.data);
            signalController?.abort();
          }
        } catch {
          console.warn('Failed to parse SSE data:', event.data);
          reject(new Error('Error parsing data'));
        }
      },

      onclose() {
        if (endEventReceived) {
          return;
        }
        // Server closed unexpectedly without sending 'end'
        reject(new Error('Stream closed unexpectedly'));
      },

      onerror(err) {
        reject(err);
        // throw err;
      },
    });
  });

}